module.exports = __webpack_public_path__ + "static/media/banner@1x.8772d3ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/projects/elavon/src/banner@1x.jpg
// module id = 585
// module chunks = 0